import { Component, OnInit } from "@angular/core";
import { GruposPagoService } from "src/app/services/grupos-pago/grupos-pago.service";
import { AlertDialogComponent } from "../alert-dialog/alert-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { DialogCodigoFirma } from "./codigo-firma.component";
import { DialogSegundoCodigoFirma } from "./codigo-segunda-firma.component";
import { DialogExportarExcel } from "./exportar-excel.component";
import { ConfirmationDialog } from "../confirmation-dialog/confirmation-dialog.component";
import Swal from "sweetalert2";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as XLSX from "xlsx";
import { environment } from '../../../environments/environment';

@Component({
  selector: "app-grupos-pago",
  templateUrl: "../../pages/grupos-pago/grupos-pago.component.html",
  styleUrls: ["../../pages/grupos-pago/grupos-pago.component.css"],
})
export class GruposPagoComponent implements OnInit {
  rol: string = localStorage.getItem("rol");
  nombreUsuario: string = localStorage.getItem("nombreUsuario");


 config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 5,  paginasTotal: 5 }
recarga: boolean = false
  buscador: any =
    {
      rut: '', region: '0', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idPlanPago: '',
      estado: ['INGRESADA', 'RECHAZADA', 'APROBADA', 'PENDIENTE'],
      paginasTotal: 5, estadoselect: ['INGRESADA', 'APROBADA']
    }
  fileName = "exportar_postulaciones.xlsx";
  tipoDocumento = "";
  agrupaciones: any = [];
  estado: any = "CREADO";
  estados: any = ["CREADO", "FIRMADO", "PAGADO"];

  constructor(
    private gruposPagoService: GruposPagoService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    let vm = this;
  
    this.postulacionesDisponiblesBuscador(false);
  }

  buscarOpcion(){
    this.buscador.itemsPerPage=this.config.itemsPerPage
    this.postulacionesDisponiblesBuscador(false)
  }

  postulacionesDisponiblesBuscador(recarga?: boolean) {
    let vm = this;
    if (recarga) {
      vm.config.currentPage = 1, vm.buscador.currentPage = 1
      this.buscador.region = "0";
      this.buscador.estadoselect = ['INGRESADA', 'APROBADA'];
      this.buscador.rut = '';
      this.buscador.fechaInicio = '';
      this.buscador.fechaFin = '';
      this.buscador.id = '';
      this.buscador.idPlanPago = '';
    }
   

    this.buscador.estado = this.buscador.estadoselect;

    this.agrupaciones = [];
    this.gruposPagoService
      .traeAgrupaciones(this.estado,this.buscador)
      .then((agrupaciones: any) => {
        agrupaciones.resultado.forEach((agrupacion) => {
          agrupacion.postulaciones = "";

          agrupacion.postulacion.forEach((postulacion, index) => {
            agrupacion.postulaciones += postulacion.id;

            if (agrupacion.postulacion.length - 1 > index) {
              agrupacion.postulaciones += ", ";
            }
            
          });
          
        });
      
        vm.agrupaciones =  agrupaciones.resultado;
        vm.buscador.paginasTotal =  agrupaciones.cantidadPaginas
        vm.config.totalItems = agrupaciones.cantidadRegistros
        /*if (this.buscador.currentPage < agrupaciones.cantidadPaginas && this.buscador.currentPage == 1) {
          this.config.itemsPerPage = agrupaciones.resultado.length
        }*/
      })
      .catch((error) => {
        console.log(error);
       
        vm.openAlertDialog(
          "No hay registros disponibles para los agrupadores seleccionados.",
          "btn-dark"
        );
       
      });
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: {
        message: mensaje,
        clase: clase,
        buttonText: { cancel: "Listo!" },
      },
    });
  }

  obtenerExcel(agrupacionId: any,estado: any) {
    let vm = this;

    if(estado != null && estado=='PAGADO') {
      this.tipoDocumento ='EXCEL_PAGO_AGRUPADOR';
    }else{
      this.tipoDocumento ='EXCEL_CREAR_AGRUPADOR';
    }
    
    this.gruposPagoService.traePdf(agrupacionId, this.tipoDocumento).then
    (
        (archivos: any) =>
        {                
            archivos.forEach( archivo => {
                var fileURL=`${environment.urlBlob}/${archivo.ubicacion}`   
                console.log("fileURL:",fileURL)          
                window.open(fileURL);
            })  
           
        } 
    )
    .catch
    (
        error =>
        {
            console.log(error)
            vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
        }
    )
  }
  
  exportexcel(agrupacionId: any): void {
    this.loadData();
    let vm = this;
    let data: any = {};
    this.gruposPagoService
      .traePostulacionesPorAgrupId(agrupacionId)
      .then((agrupaciones: any) => {
        Swal.fire({
          allowOutsideClick: false,
          icon: "info",
          text: "Cargando...",
        });
        Swal.showLoading();
   
        vm.agrupaciones = agrupaciones;
        vm.config.totalItems = agrupaciones.length;
        data = agrupaciones; 
     
        const dialogRef = this.dialog.open(DialogExportarExcel, {
          width: "30%",
          data: data,
        });
        setTimeout(() => {
          let element = document.getElementById("excel-tables");
          const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
       
          dialogRef.close();
          /* generate workbook and add the worksheet */
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
        
          XLSX.utils.book_append_sheet(wb, ws, "Hoja1");
          /* save to file */
          XLSX.writeFile(wb, this.fileName);      
          this.estado= vm.estado;
          vm.loadData() 
        }, 1000);
        // dialogRef.afterClosed().subscribe( () => { if(data.recarga) vm.exportexcel(agrupacionId) })
      
        Swal.close();
      })
      .catch((error) => {
        Swal.close();
        vm.openAlertDialog(
          "No hay registros disponibles para el estado seleccionado.",
          "btn-dark"
        );
      });
   
  }

  eliminarAgrupacion(idGrupo: any) {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: {
        message: "¿Estás seguro de eliminar la agrupación de pago?",
        buttonText: { ok: "Si", cancel: "No" },
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        let vm = this; 
        this.gruposPagoService
          .eliminarAgrupacion(idGrupo)
          .then(() =>
          {
            vm.openAlertDialog(
              "La agrupación se ha eliminado exitosamente.",
              "btn-success"
            )
            this.estado= vm.estado;
            vm.loadData() 
          }           

          )
          .catch((error) => {
            console.log(error);
            vm.openAlertDialog(
              "Ha ocurrido un error al eliminar la agrupación.",
              "btn-danger"
            );
          }); 
      
      
      }
    });
  }

  openCodigoFirmaDialog(agrupacionId: any) {
    let vm = this;

    let data = { idGrupo: agrupacionId, recarga: false };

    const dialogRef = this.dialog.open(DialogCodigoFirma, {
      width: "30%",
      data: data,
    });

    dialogRef.afterClosed().subscribe(() => {
      if (data.recarga) vm.loadData();
    });
  }

  openCodigoSegundaFirmaDialog(agrupacionId: any) {
    let vm = this;

    let data = { idGrupo: agrupacionId, recarga: false };

    const dialogRef = this.dialog.open(DialogSegundoCodigoFirma, {
      width: "30%",
      data: data,
    });

    dialogRef.afterClosed().subscribe(() => {
      if (data.recarga) vm.loadData();
    });
  }

  pdfFirmado(agrupacionId: any) {
    let vm = this;
    
    this.tipoDocumento ='PDF_GENERADO';
    this.gruposPagoService.traePdf(agrupacionId, this.tipoDocumento).then
    (
        (archivos: any) =>
        {                
            archivos.forEach( archivo => {
                var fileURL=`${environment.urlBlob}/${archivo.ubicacion}`   
                console.log("fileURL:",fileURL)          
                window.open(fileURL);
            })  
           
        } 
    )
    .catch
    (
        error =>
        {
            console.log(error)
            vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
        }
    )
  }


  onPagarClick(agrupacionId: any): void
    {
        let vm = this

        let data = { idGrupo: agrupacionId, recarga: false };
      

        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de pagar la agrupación?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed)
            {
              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
              this.gruposPagoService.pagarAgrupacion(agrupacionId).then
                (
                    (response: any) =>
                    {
                       this.estado= vm.estado;
                        vm.loadData() 
                        Swal.close();            
                        vm.openAlertDialog('La agrupación se ha enviado a pago, en los próximos minutos se actualizará.', 'btn-success')
                    }
                )
                .catch
                (
                    error =>
                    {
                        Swal.close();
                        console.log(error)
                        dialogRef.afterClosed().subscribe(() => {
                          if (data.recarga) vm.loadData();
                        });
                        vm.openAlertDialog('La agrupación no se ha logrado pagar.', 'btn-danger')
                    }
                )
            }
        })
    }
    /*
  pageChanged(event: any) {
    this.config.currentPage = event;
  }
  */
    
  pageChanged(event: any) {
    this.config.currentPage = event, 
    this.buscador.currentPage = event       
    this.postulacionesDisponiblesBuscador(false)
    this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
    this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)

  }


  reenviarPagosPS(agrupacionId: any) {
    let vm = this;
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: { message: '¿Esta realmente seguro de reenviar lo que quedo pendiente a PS?', buttonText: { ok: 'Si', cancel: 'No' } }
    })

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        Swal.fire({
          allowOutsideClick: false,
          icon: 'info',
          text: 'Cargando...'
        });
        Swal.showLoading();
        this.gruposPagoService.reenviarPagosPS(agrupacionId).then
          (
            (response: any) => {
              vm.loadData()
              Swal.close();
              vm.openAlertDialog('Se ha enviado a PS lo que estaba pendiente.', 'btn-success')

            }
          )
          .catch
          (
            error => {
              console.log(error)
              vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
          )
      }
    })
  }
}
